import { render, staticRenderFns } from "./PageForgotPasswordConfirmCode.vue?vue&type=template&id=7eb23bc0&"
import script from "./PageForgotPasswordConfirmCode.vue?vue&type=script&lang=ts&"
export * from "./PageForgotPasswordConfirmCode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports